import { BulbOutlined, CheckSquareOutlined } from '@ant-design/icons'
import { MenuInfo } from 'rc-menu/lib/interface.d'
import React from 'react'

import Menu from 'components/atoms/Menu'
import { LD_TOGGLE_FEATURES } from 'config/launchDarkly'
import {
  NOTIFICATION,
  NOTIFICATION_STATUS,
  NOTIFICATION_TYPE,
  NotificationGroup,
} from 'config/notification'
import { useMeNotificationGroups } from 'hooks/me/useMeNotificationGroups'
import { useVariation } from 'hooks/useVariation'
import { useDrawer } from 'providers/Drawer'
import { NotificationDrawerTab } from 'providers/Drawer/drawers/Notification'
import Badge from 'stories/components/atoms/Badge/Badge'

const Sider = () => {
  const { tab, changeTab } = useDrawer()

  const handleClick = ({ key }: MenuInfo) => {
    changeTab(key as NotificationDrawerTab)
  }

  const { variation: notificationAndAccessEnabled } = useVariation(
    LD_TOGGLE_FEATURES.NOTIFICATION_AND_ACCESS_WORKFLOW_STEP
  )

  const { notificationGroups: notificationGroupsTask = [] } =
    useMeNotificationGroups({
      notificationType: NOTIFICATION_TYPE.TASK,
      notificationStatus: [
        NOTIFICATION_STATUS.READ,
        NOTIFICATION_STATUS.UNREAD,
      ],
    })

  const { notificationGroups: notificationGroupsInfo = [] } =
    useMeNotificationGroups({
      notificationType: NOTIFICATION_TYPE.INFO,
      notificationStatus: [
        NOTIFICATION_STATUS.READ,
        NOTIFICATION_STATUS.UNREAD,
      ],
    })

  const notificationGroupsFilteredByFeatureFlag = (
    notificationGroups: NotificationGroup[]
  ): NotificationGroup[] =>
    notificationGroups?.filter(({ slug }) => {
      if (slug === NOTIFICATION.INFO_NEW_TRANSACTION_EVENT) {
        return notificationAndAccessEnabled
      }
      return true
    })

  return (
    <Menu
      selectedKeys={[tab]}
      mode="inline"
      style={{ height: '100%' }}
      menu={[
        {
          icon: (
            <Badge
              count={notificationGroupsTask?.length}
              status={'default'}
              size="small"
            >
              <CheckSquareOutlined style={{ lineHeight: 'normal' }} />
            </Badge>
          ),
          title: 'word.tasks',
          key: NotificationDrawerTab.tasks,
          onClick: handleClick,
        },
        {
          icon: (
            <Badge
              count={
                notificationGroupsFilteredByFeatureFlag(
                  notificationGroupsInfo
                )?.filter(({ status }) => status === NOTIFICATION_STATUS.UNREAD)
                  ?.length
              }
              status={'default'}
              size="small"
            >
              <BulbOutlined style={{ lineHeight: 'normal' }} />
            </Badge>
          ),
          title: 'word.informations',
          key: NotificationDrawerTab.informations,
          onClick: handleClick,
        },
      ]}
    />
  )
}

export default React.memo(Sider)
